<template>
  <v-container
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
    dashboard
  >
    <helper-suspended ref="suspended" />
    <v-layout
      wrap
    >
      <v-flex
        v-if="!getTraderMode && getUser != null && getUser.count_accounts == 0"
        xs12
      >
        <v-card
          style="padding:7px;"
        >
          <v-layout wrap>
            <v-flex
              xs12
              pl-5
              align-self-center
            >
              <v-icon style="margin: -2px 7px 0 0;">
                mdi-lightbulb-on-outline
              </v-icon>
              <small style="font-weight:500;">{{ $t('dashboard.startMessage') }}
                <b>
                  <a
                    :href="$i18n.locale =='ru' ? `https://aivia.io/blog/ru/for-investor/` : `https://aivia.io/blog/en/for-investor/`"
                    target="_blank"
                  >{{ $t('dashboard.instruction') }}
                  </a>
                </b>
              </small>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex
        md6
        xs12
      >
        <portfolio-details />
      </v-flex>
     

      <v-flex
        md6
        xs12
      >
        <v-card
          height="100%"
        >
          <v-card-title>{{ $t('dashboard.portfolioAssets') }}</v-card-title>
          <assets-chart />
        </v-card>
      </v-flex>

      <v-flex
        md12
        xs12
      >
        <v-card height="100%">
          <v-card-title>{{ $t('dashboard.assetsOverview') }}</v-card-title>
          <assets-history />
        </v-card>
      </v-flex>

      <v-flex
        md12
        xs12
      >
        <v-tabs :value="tab">
          <v-tab
            v-for="(n,i) in [$t('dashboard.pnlChart')]"
            :key="i"
            @click="changeTab(i)"
          >
            {{ n }}
          </v-tab>
        </v-tabs>
        <v-card class="details-card">
          <v-flex
            v-show="tab == 0"
            xs12
            md12
            data
          >
            <pnl-chart />
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import AssetsChart from "@/views/Portfolio/partial/AssetsChart.vue";
import AssetsHistory from "@/views/Portfolio/partial/AssetsHistory.vue";
import PnlChart from "@/views/Portfolio/partial/PnLChart.vue";
import PortfolioDetails from "@/views/Portfolio/partial/PortfolioDetails.vue";

export default {
  name: "Porfolio",
  components: {
    AssetsChart,
    AssetsHistory,
    PnlChart,
    PortfolioDetails
  },
  data: () => ({
    tab: 0,
    tooltip: null,
    loading: false,
    traderMode: false,
    countAccs: 0,
    countProjects: 0
  }),
  computed: {
    ...mapGetters("app", ["getTraderMode"]),
    ...mapGetters("user", ["getUser", "getUserSettings"])
  },
  mounted() {
    if (this.getUserSettings && this.getUserSettings.status == 'suspended') {
      this.$refs.suspended.open();
    }
  },
  methods: {
    changeTab(i) {
      this.tab = i;
    }
  },
};
</script>



<style lang="scss" >
@import "@/styles/material-dashboard/_colors.scss";

.dashboard {
  .v-avatar {
    border-radius: 50% !important;
    border: 1px solid #173eb7 !important;
    margin-top: -2px;
    background: white !important;
    .v-icon {
      color: #173eb7;
    }
  }
  .main-text {
    font-weight: 600;
    font-size: 16px;
    color: $black;
  }
}

</style>
